import { render, staticRenderFns } from "./ItemDescription2.vue?vue&type=template&id=fe009fd0&"
import script from "./ItemDescription2.vue?vue&type=script&lang=js&"
export * from "./ItemDescription2.vue?vue&type=script&lang=js&"
import style0 from "./ItemDescription2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports